import { CardOnFile } from './PaymentMethodTypes'

export type CardOnFileSource = Omit<CardOnFile, 'hasPaymentSubscription'> & {
  paymentSubscriptions?: Array<unknown> | null
}

export const convertPaymentMethodRecordToCardOnFile = (row: CardOnFileSource): CardOnFile => {
  const { paymentSubscriptions, ...rest } = row

  return {
    ...rest,
    paymentMethodType: row.paymentMethodType,
    hasPaymentSubscription: (paymentSubscriptions ?? []).length > 0,
  }
}
